import React from 'react'
import './NoConnection.scss'
import video1 from '../../assets/Video/pexelscottonbro.mp4'

const NoConnection = () => {
  return (
    <div className="no-connection-page">
    <video
      autoPlay
      loop
      muted
      className="background-video"
    >
      <source src={video1} type="video/mp4" />
      {/* Add more source elements for different video formats if needed */}
    </video>
    <div className="overlay">
      <h1>No Connection Available</h1>
      <p>Please check your internet connection and try again.</p>
    </div>
  </div>
  )
}

export default NoConnection